import { SvgIconProps } from '@traba/types'

export default function Neo({
  size = 24,
  color = 'currentColor',
  ...props
}: SvgIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12" fill="none" {...props}>
      <path
        d="M5.33089 10.4747C5.55426 11.1751 6.44574 11.1751 6.66911 10.4747L7.43466 8.07409C7.50616 7.84988 7.6649 7.67351 7.86668 7.59406L10.0272 6.74345C10.6576 6.49527 10.6576 5.50473 10.0272 5.25655L7.86668 4.40593C7.6649 4.32649 7.50616 4.15011 7.43466 3.92591L6.66911 1.52531C6.44574 0.824895 5.55426 0.824896 5.33089 1.52531L4.56534 3.92591C4.49384 4.15011 4.3351 4.32649 4.13332 4.40593L1.97278 5.25655C1.34241 5.50473 1.34241 6.49527 1.97278 6.74345L4.13332 7.59406C4.3351 7.67351 4.49384 7.84988 4.56534 8.07409L5.33089 10.4747Z"
        fill={color}
      />
    </svg>
  )
}
